import * as types from 'models/actionTypes'

export const quickPreviewClose = () => ({
    type: types.QUICK_PREVIEW_CLOSE,
})

export const dragValidityChange = (isValid) => ({
    type: types.DRAG_VALIDITY_CHANGE,
    isValid,
})

export const updatePreviewSettings = (settings) => ({
    type: types.UPDATE_PREVIEW_SETTINGS,
    settings,
})

export const showPlaceableSurfaces = (surfaces) => ({
    type: types.SHOW_PLACEABLE_SURFACES,
    surfaces,
})

export const hidePlaceableSurfaces = () => ({
    type: types.HIDE_PLACEABLE_SURFACES,
})

export const setIsMagicWindowLoading = (isMagicWindowLoading) => ({
    type: types.SET_MAGIC_WINDOW_LOADING,
    isMagicWindowLoading,
})

export const setInitialLoading = (initialLoading) => ({
    type: types.SET_INITIAL_LOADING,
    initialLoading,
})

export const wallDataReady = (wallDataWidth, wallDataHeight) => ({
    type: types.WALLDATA_READY,
    wallDataWidth,
    wallDataHeight,
})
